module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navigation fk__navigation",
    class: {
      'fk__navigation--dark': _vm.darkMenu, 'fk__navigation--fixed': _vm.fixedMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('svg', {
    staticClass: "fk__navigation__logo",
    staticStyle: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "1.41421"
    },
    attrs: {
      "width": "100%",
      "height": "100%",
      "viewBox": "0 0 378 79",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "xml:space": "preserve"
    }
  }, [_c('title', [_vm._v("Famous King")]), _vm._v(" "), _c('rect', {
    staticStyle: {
      "fill": "none"
    },
    attrs: {
      "id": "Artboard1",
      "x": "0",
      "y": "0",
      "width": "377.108",
      "height": "78.666"
    }
  }), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "_clip1"
    }
  }, [_c('rect', {
    attrs: {
      "id": "Artboard11",
      "x": "0",
      "y": "0",
      "width": "377.108",
      "height": "78.666"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "clip-path": "url(#_clip1)"
    }
  }, [_c('g', {
    attrs: {
      "transform": "matrix(1,0,0,1,10,10)"
    }
  }, [_c('path', {
    staticClass: "fk__navigation__logo__letter",
    staticStyle: {
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M181.684,18.804L181.684,20.7L173.428,20.7L173.428,26.712L180.484,26.712L180.484,28.608L173.428,28.608L173.428,36L171.088,36L171.088,18.804L181.684,18.804Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fk__navigation__logo__letter",
    staticStyle: {
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M199.836,36L198.036,36C197.828,36 197.66,35.948 197.532,35.844C197.404,35.74 197.308,35.608 197.244,35.448L195.636,31.296L187.92,31.296L186.312,35.448C186.256,35.592 186.16,35.72 186.024,35.832C185.888,35.944 185.72,36 185.52,36L183.72,36L190.596,18.804L192.96,18.804L199.836,36ZM188.568,29.616L194.988,29.616L192.288,22.62C192.112,22.188 191.94,21.648 191.772,21C191.684,21.328 191.598,21.63 191.514,21.906C191.43,22.182 191.348,22.424 191.268,22.632L188.568,29.616Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fk__navigation__logo__letter",
    staticStyle: {
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M213.068,29.784C213.18,29.976 213.278,30.178 213.362,30.39C213.446,30.602 213.528,30.816 213.608,31.032C213.688,30.808 213.772,30.594 213.86,30.39C213.948,30.186 214.048,29.98 214.16,29.772L219.98,19.2C220.084,19.016 220.192,18.904 220.304,18.864C220.416,18.824 220.576,18.804 220.784,18.804L222.5,18.804L222.5,36L220.46,36L220.46,23.364C220.46,23.196 220.464,23.016 220.472,22.824C220.48,22.632 220.492,22.436 220.508,22.236L214.616,32.988C214.416,33.348 214.136,33.528 213.776,33.528L213.44,33.528C213.08,33.528 212.8,33.348 212.6,32.988L206.576,22.2C206.6,22.408 206.618,22.612 206.63,22.812C206.642,23.012 206.648,23.196 206.648,23.364L206.648,36L204.608,36L204.608,18.804L206.324,18.804C206.532,18.804 206.692,18.824 206.804,18.864C206.916,18.904 207.024,19.016 207.128,19.2L213.068,29.784Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fk__navigation__logo__letter",
    staticStyle: {
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M245.26,27.408C245.26,28.696 245.056,29.878 244.648,30.954C244.24,32.03 243.664,32.956 242.92,33.732C242.176,34.508 241.282,35.11 240.238,35.538C239.194,35.966 238.04,36.18 236.776,36.18C235.512,36.18 234.36,35.966 233.32,35.538C232.28,35.11 231.388,34.508 230.644,33.732C229.9,32.956 229.324,32.03 228.916,30.954C228.508,29.878 228.304,28.696 228.304,27.408C228.304,26.12 228.508,24.938 228.916,23.862C229.324,22.786 229.9,21.858 230.644,21.078C231.388,20.298 232.28,19.692 233.32,19.26C234.36,18.828 235.512,18.612 236.776,18.612C238.04,18.612 239.194,18.828 240.238,19.26C241.282,19.692 242.176,20.298 242.92,21.078C243.664,21.858 244.24,22.786 244.648,23.862C245.056,24.938 245.26,26.12 245.26,27.408ZM242.872,27.408C242.872,26.352 242.728,25.404 242.44,24.564C242.152,23.724 241.744,23.014 241.216,22.434C240.688,21.854 240.048,21.408 239.296,21.096C238.544,20.784 237.704,20.628 236.776,20.628C235.856,20.628 235.02,20.784 234.268,21.096C233.516,21.408 232.874,21.854 232.342,22.434C231.81,23.014 231.4,23.724 231.112,24.564C230.824,25.404 230.68,26.352 230.68,27.408C230.68,28.464 230.824,29.41 231.112,30.246C231.4,31.082 231.81,31.79 232.342,32.37C232.874,32.95 233.516,33.394 234.268,33.702C235.02,34.01 235.856,34.164 236.776,34.164C237.704,34.164 238.544,34.01 239.296,33.702C240.048,33.394 240.688,32.95 241.216,32.37C241.744,31.79 242.152,31.082 242.44,30.246C242.728,29.41 242.872,28.464 242.872,27.408Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fk__navigation__logo__letter",
    staticStyle: {
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M257.624,34.152C258.336,34.152 258.972,34.032 259.532,33.792C260.092,33.552 260.566,33.216 260.954,32.784C261.342,32.352 261.638,31.836 261.842,31.236C262.046,30.636 262.148,29.976 262.148,29.256L262.148,18.804L264.464,18.804L264.464,29.256C264.464,30.248 264.306,31.168 263.99,32.016C263.674,32.864 263.222,33.598 262.634,34.218C262.046,34.838 261.328,35.324 260.48,35.676C259.632,36.028 258.68,36.204 257.624,36.204C256.568,36.204 255.616,36.028 254.768,35.676C253.92,35.324 253.2,34.838 252.608,34.218C252.016,33.598 251.562,32.864 251.246,32.016C250.93,31.168 250.772,30.248 250.772,29.256L250.772,18.804L253.088,18.804L253.088,29.244C253.088,29.964 253.19,30.624 253.394,31.224C253.598,31.824 253.894,32.34 254.282,32.772C254.67,33.204 255.146,33.542 255.71,33.786C256.274,34.03 256.912,34.152 257.624,34.152Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fk__navigation__logo__letter",
    staticStyle: {
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M279.868,21.492C279.796,21.612 279.72,21.702 279.64,21.762C279.56,21.822 279.456,21.852 279.328,21.852C279.192,21.852 279.034,21.784 278.854,21.648C278.674,21.512 278.446,21.362 278.17,21.198C277.894,21.034 277.562,20.884 277.174,20.748C276.786,20.612 276.316,20.544 275.764,20.544C275.244,20.544 274.784,20.614 274.384,20.754C273.984,20.894 273.65,21.084 273.382,21.324C273.114,21.564 272.912,21.846 272.776,22.17C272.64,22.494 272.572,22.844 272.572,23.22C272.572,23.7 272.69,24.098 272.926,24.414C273.162,24.73 273.474,25 273.862,25.224C274.25,25.448 274.69,25.642 275.182,25.806C275.674,25.97 276.178,26.14 276.694,26.316C277.21,26.492 277.714,26.69 278.206,26.91C278.698,27.13 279.138,27.408 279.526,27.744C279.914,28.08 280.226,28.492 280.462,28.98C280.698,29.468 280.816,30.068 280.816,30.78C280.816,31.532 280.688,32.238 280.432,32.898C280.176,33.558 279.802,34.132 279.31,34.62C278.818,35.108 278.214,35.492 277.498,35.772C276.782,36.052 275.968,36.192 275.056,36.192C273.944,36.192 272.93,35.99 272.014,35.586C271.098,35.182 270.316,34.636 269.668,33.948L270.34,32.844C270.404,32.756 270.482,32.682 270.574,32.622C270.666,32.562 270.768,32.532 270.88,32.532C271.048,32.532 271.24,32.622 271.456,32.802C271.672,32.982 271.942,33.18 272.266,33.396C272.59,33.612 272.982,33.81 273.442,33.99C273.902,34.17 274.464,34.26 275.128,34.26C275.68,34.26 276.172,34.184 276.604,34.032C277.036,33.88 277.402,33.666 277.702,33.39C278.002,33.114 278.232,32.784 278.392,32.4C278.552,32.016 278.632,31.588 278.632,31.116C278.632,30.596 278.514,30.17 278.278,29.838C278.042,29.506 277.732,29.228 277.348,29.004C276.964,28.78 276.526,28.59 276.034,28.434C275.542,28.278 275.038,28.118 274.522,27.954C274.006,27.79 273.502,27.6 273.01,27.384C272.518,27.168 272.08,26.888 271.696,26.544C271.312,26.2 271.002,25.77 270.766,25.254C270.53,24.738 270.412,24.1 270.412,23.34C270.412,22.732 270.53,22.144 270.766,21.576C271.002,21.008 271.344,20.504 271.792,20.064C272.24,19.624 272.794,19.272 273.454,19.008C274.114,18.744 274.872,18.612 275.728,18.612C276.688,18.612 277.564,18.764 278.356,19.068C279.148,19.372 279.84,19.812 280.432,20.388L279.868,21.492Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fk__navigation__logo__letter",
    staticStyle: {
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M296.068,26.34L296.944,26.34C297.248,26.34 297.49,26.302 297.67,26.226C297.85,26.15 298.02,26.02 298.18,25.836L303.904,19.356C304.08,19.156 304.25,19.014 304.414,18.93C304.578,18.846 304.788,18.804 305.044,18.804L307.024,18.804L300.472,26.208C300.304,26.392 300.146,26.548 299.998,26.676C299.85,26.804 299.692,26.908 299.524,26.988C299.748,27.06 299.944,27.168 300.112,27.312C300.28,27.456 300.456,27.636 300.64,27.852L307.48,36L305.464,36C305.312,36 305.184,35.988 305.08,35.964C304.976,35.94 304.886,35.908 304.81,35.868C304.734,35.828 304.664,35.776 304.6,35.712C304.536,35.648 304.472,35.58 304.408,35.508L298.468,28.68C298.38,28.584 298.298,28.502 298.222,28.434C298.146,28.366 298.058,28.308 297.958,28.26C297.858,28.212 297.742,28.178 297.61,28.158C297.478,28.138 297.316,28.128 297.124,28.128L296.068,28.128L296.068,36L293.752,36L293.752,18.804L296.068,18.804L296.068,26.34Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "fk__navigation__logo__letter",
    staticStyle: {
      "fill-rule": "nonzero"
    },
    attrs: {
      "x": "312.888",
      "y": "18.804",
      "width": "2.328",
      "height": "17.196"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fk__navigation__logo__letter",
    staticStyle: {
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M323.624,18.804C323.832,18.804 323.986,18.83 324.086,18.882C324.186,18.934 324.3,19.04 324.428,19.2L334.388,32.16C334.364,31.952 334.348,31.75 334.34,31.554C334.332,31.358 334.328,31.168 334.328,30.984L334.328,18.804L336.368,18.804L336.368,36L335.192,36C335.008,36 334.854,35.968 334.73,35.904C334.606,35.84 334.484,35.732 334.364,35.58L324.416,22.632C324.432,22.832 324.444,23.028 324.452,23.22C324.46,23.412 324.464,23.588 324.464,23.748L324.464,36L322.424,36L322.424,18.804L323.624,18.804Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fk__navigation__logo__letter",
    staticStyle: {
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M350.736,34.308C351.2,34.308 351.626,34.286 352.014,34.242C352.402,34.198 352.768,34.132 353.112,34.044C353.456,33.956 353.78,33.85 354.084,33.726C354.388,33.602 354.692,33.46 354.996,33.3L354.996,29.508L352.332,29.508C352.18,29.508 352.058,29.464 351.966,29.376C351.874,29.288 351.828,29.18 351.828,29.052L351.828,27.732L357.108,27.732L357.108,34.332C356.676,34.644 356.226,34.916 355.758,35.148C355.29,35.38 354.79,35.574 354.258,35.73C353.726,35.886 353.156,36.002 352.548,36.078C351.94,36.154 351.28,36.192 350.568,36.192C349.32,36.192 348.176,35.978 347.136,35.55C346.096,35.122 345.2,34.522 344.448,33.75C343.696,32.978 343.11,32.052 342.69,30.972C342.27,29.892 342.06,28.704 342.06,27.408C342.06,26.096 342.266,24.9 342.678,23.82C343.09,22.74 343.678,21.814 344.442,21.042C345.206,20.27 346.13,19.672 347.214,19.248C348.298,18.824 349.512,18.612 350.856,18.612C351.536,18.612 352.168,18.662 352.752,18.762C353.336,18.862 353.878,19.006 354.378,19.194C354.878,19.382 355.34,19.61 355.764,19.878C356.188,20.146 356.584,20.448 356.952,20.784L356.292,21.84C356.156,22.056 355.98,22.164 355.764,22.164C355.636,22.164 355.496,22.12 355.344,22.032C355.144,21.92 354.92,21.784 354.672,21.624C354.424,21.464 354.122,21.31 353.766,21.162C353.41,21.014 352.99,20.888 352.506,20.784C352.022,20.68 351.448,20.628 350.784,20.628C349.816,20.628 348.94,20.786 348.156,21.102C347.372,21.418 346.704,21.87 346.152,22.458C345.6,23.046 345.176,23.758 344.88,24.594C344.584,25.43 344.436,26.368 344.436,27.408C344.436,28.496 344.59,29.466 344.898,30.318C345.206,31.17 345.64,31.892 346.2,32.484C346.76,33.076 347.424,33.528 348.192,33.84C348.96,34.152 349.808,34.308 350.736,34.308Z"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(1,0,0,1,10,10)"
    }
  }, [_c('clipPath', {
    attrs: {
      "id": "_clip2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M92.535,40.552C88.893,44.204 84.038,46.235 78.866,46.27L78.765,46.27C76.235,46.27 73.907,45.64 71.859,44.725L71.768,42.353L71.666,39.675L69.41,41.103L67.623,42.234C64.817,40.171 63.115,38.055 62.979,37.882L52.598,24.708L53.432,22.397L54.341,19.877L51.716,20.346L49.477,20.745L44.395,14.296L44.376,14.311L43.298,12.919C40.309,9.015 36.276,6.252 31.742,4.9L30.901,2.568L29.993,0.048L28.276,2.099L26.682,4.003C26.204,3.973 25.723,3.957 25.24,3.957C16.691,3.957 9.229,8.717 5.334,15.739L2.834,15.983L0.181,16.243L1.731,18.423L3.282,20.604L3.413,20.313C2.797,22.386 2.465,24.581 2.465,26.854C2.465,33.343 5.164,39.209 9.493,43.38L9.161,45.96L8.82,48.618L11.28,47.586L13.686,46.578C17.075,48.592 21.025,49.75 25.24,49.75C29.58,49.75 33.803,48.513 37.453,46.171C37.939,45.859 38.411,45.528 38.87,45.182L41.28,45.932L43.827,46.725L43.237,44.111L42.665,41.578C43.632,40.422 44.489,39.172 45.216,37.84L42.848,34.834C40.286,40.553 35.113,44.674 29.013,45.894L27.567,43.897L25.998,41.73L24.916,44.179L24.012,46.226C16.692,45.762 10.47,41.181 7.609,34.764L9.239,33.053L11.082,31.117L8.493,30.48L6.168,29.909C6.011,28.913 5.927,27.893 5.927,26.854C5.927,20.363 9.114,14.611 13.994,11.084L16.202,12.365L18.511,13.705L18.511,11.025L18.511,8.656C20.607,7.87 22.874,7.438 25.24,7.438C29.827,7.438 34.196,9.076 37.632,11.971L36.955,13.847L36.047,16.367L38.671,15.898L40.897,15.501C40.986,15.624 41.074,15.748 41.16,15.874L48.324,24.966L48.331,24.897L54.857,33.18L53.982,35.221L52.926,37.683L55.574,37.371L57.94,37.093L60.25,40.025C60.565,40.43 67.947,49.751 78.764,49.751L78.884,49.75C79.251,49.748 79.616,49.736 79.98,49.717L81.672,51.652L83.431,53.666L84.286,51.127L85.044,48.877C88.769,47.82 92.179,45.826 94.98,43.016C95.054,42.943 95.127,42.868 95.2,42.793L93.029,40.038C92.867,40.213 92.703,40.384 92.535,40.552Z"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "clip-path": "url(#_clip2)"
    }
  }, [_c('rect', {
    staticStyle: {
      "fill": "rgb(244,205,28)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "x": "-4.819",
      "y": "-4.952",
      "width": "105.019",
      "height": "63.618"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "_clip3"
    }
  }, [_c('path', {
    attrs: {
      "d": "M149.965,37.58L148.413,35.4L146.864,33.219L146.733,33.51C147.349,31.437 147.681,29.242 147.681,26.97C147.681,20.481 144.983,14.614 140.653,10.444L140.985,7.863L141.327,5.205L138.866,6.237L136.46,7.246C133.069,5.231 129.121,4.073 124.906,4.073C120.566,4.073 116.342,5.311 112.693,7.652C112.206,7.964 111.735,8.296 111.275,8.642L108.865,7.891L106.319,7.099L106.909,9.712L107.481,12.245C106.513,13.401 105.657,14.652 104.929,15.984L107.297,18.989C109.86,13.271 115.033,9.149 121.132,7.93L122.578,9.927L124.147,12.094L125.23,9.644L126.134,7.597C133.453,8.061 139.676,12.642 142.537,19.059L140.906,20.77L139.064,22.706L141.653,23.343L143.978,23.915C144.134,24.91 144.218,25.93 144.218,26.97C144.218,33.46 141.032,39.212 136.151,42.74L133.943,41.459L131.634,40.119L131.634,42.799L131.636,45.168C129.54,45.954 127.272,46.386 124.906,46.386C120.318,46.386 115.95,44.747 112.514,41.852L113.19,39.976L114.099,37.457L111.474,37.925L109.249,38.323C109.16,38.199 109.072,38.075 108.985,37.95L101.821,28.857L101.814,28.926L95.288,20.643L96.164,18.602L97.22,16.141L94.572,16.452L92.205,16.73L89.896,13.799C89.58,13.394 82.199,4.073 71.382,4.073L71.262,4.073C70.856,4.076 70.452,4.09 70.05,4.113L68.529,2.237L66.845,0.159L65.897,2.664L65.025,4.969C61.33,6.032 57.948,8.017 55.165,10.807C55.092,10.881 55.019,10.955 54.946,11.03L57.116,13.786C57.278,13.611 57.443,13.439 57.61,13.272C61.253,9.619 66.107,7.589 71.28,7.554L71.38,7.554C73.91,7.554 76.239,8.184 78.287,9.098L78.377,11.471L78.48,14.149L80.736,12.721L82.522,11.589C85.329,13.653 87.031,15.769 87.167,15.941L97.547,29.116L96.714,31.427L95.805,33.946L98.43,33.478L100.669,33.078L105.751,39.527L105.77,39.512L106.848,40.904C109.837,44.809 113.87,47.572 118.404,48.923L119.245,51.256L120.153,53.776L121.869,51.725L123.464,49.82C123.942,49.85 124.423,49.867 124.906,49.867C133.455,49.867 140.916,45.106 144.812,38.084L147.312,37.84L149.965,37.58Z"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "clip-path": "url(#_clip3)"
    }
  }, [_c('rect', {
    staticStyle: {
      "fill": "rgb(244,205,28)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "x": "49.946",
      "y": "-4.841",
      "width": "105.02",
      "height": "63.617"
    }
  })])])])])]), _vm._v(" "), _c('nav', {
    staticClass: "fk__navigation__nav",
    class: {
      'fk__navigation__nav--open': _vm.isOpen
    },
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('div', {
    staticClass: "fk__navigation__nav--first"
  }, [_vm._v(_vm._s(_vm.pageName))]), _vm._v(" "), _c('svg', {
    staticClass: "fk__navigation__nav__arrow",
    attrs: {
      "viewBox": "0 0 100 100",
      "xmlns": "http://www.w3.org/2000/svg",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "1.5"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.664 31.332L50 68.67 87.34 31.33",
      "fill": "none",
      "stroke": "#fff",
      "stroke-width": "16.38627"
    }
  })]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/mission"
    }
  }, [_vm._v("Mission")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/projects"
    }
  }, [_vm._v("Projects")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/donate"
    }
  }, [_vm._v("Donate")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("Contact")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2acf9ade"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation.vue
// module id = 75
// module chunks = 0